import { call, put, takeLatest } from 'redux-saga/effects';

import { actions } from '../actions/telephony';
import * as telephonyApi from '../api/telephony';

// Destructure the telephony actions.
export const {
  telephonyGetUsersByQuery,
  telephonyGetUsersByQuerySucceeded,
  telephonyGetUsersByQueryFailed,

  telephonyGetAllCountryCodes,
  telephonyGetAllCountryCodesSucceeded,
  telephonyGetAllCountryCodesFailed,

  telephonySetHold,
  telephonySetHoldSucceeded,
  telephonySetHoldFailed,

  telephonySetMute,
  telephonySetMuteSucceeded,
  telephonySetMuteFailed,

  telephonyRenewToken,
  telephonyRenewTokenSucceeded,
  telephonyRenewTokenFailed,

  telephonyGetAllOwnNumbers,
  telephonyGetAllOwnNumbersSucceeded,
  telephonyGetAllOwnNumbersFailed,

  telephonyGetQueryNumbers,
  telephonyGetQueryNumbersSucceeded,
  telephonyGetQueryNumbersFailed,
} = actions;

// Saga
export const telephonySagas = [
  takeLatest(
    telephonyGetUsersByQuery.toString() as any,
    genWithPromise(
      telephonyApi.searchUsers,
      telephonyGetUsersByQuerySucceeded,
      telephonyGetUsersByQueryFailed,
    ),
  ),

  takeLatest(
    telephonyRenewToken.toString() as any,
    genWithPromise(
      telephonyApi.getToken,
      telephonyRenewTokenSucceeded,
      telephonyRenewTokenFailed,
    ),
  ),

  takeLatest(
    telephonyGetQueryNumbers.toString() as any,
    genWithPromise(
      telephonyApi.getQueryNumbers,
      telephonyGetQueryNumbersSucceeded,
      telephonyGetQueryNumbersFailed,
    ),
  ),

  takeLatest(
    telephonyGetAllOwnNumbers.toString() as any,
    genWithPromise(
      telephonyApi.getAllNumbers,
      telephonyGetAllOwnNumbersSucceeded,
      telephonyGetAllOwnNumbersFailed,
    ),
  ),

  takeLatest(
    telephonyGetAllCountryCodes.toString() as any,
    genWithPromise(
      telephonyApi.getAllCountryCodes,
      telephonyGetAllCountryCodesSucceeded,
      telephonyGetAllCountryCodesFailed,
    ),
  ),

  takeLatest(
    telephonySetHold.toString() as any,
    genWithHoldMutePromise(
      telephonyApi.setHold,
      telephonySetHoldSucceeded,
      telephonySetHoldFailed,
    ),
  ),

  takeLatest(
    telephonySetMute.toString() as any,
    genWithHoldMutePromise(
      telephonyApi.setMute,
      telephonySetMuteSucceeded,
      telephonySetMuteFailed,
    ),
  ),
];

function genWithHoldMutePromise(
  apiAction: (action: any) => any,
  resultSucceededAction: (result: any) => any,
  resultFailedAction: (result: any) => any,
) {
  return function* (action: {
    payload: any;
    meta: { resolve: () => void; reject: () => void };
  }) {
    let result;
    try {
      result = yield call(apiAction, action.payload);
      result.meta.request = action.payload.setTo;

      yield call(action.meta.resolve as any, result);
      yield put(resultSucceededAction(result));
    } catch (exception) {
      console.warn(exception);
      // Something went wrong. We reject the promise.
      yield call(action.meta.reject as any, exception);
      result = exception;
      yield put(resultFailedAction(result));
    }
  };
}

function genWithPromise(
  apiAction: (action: any) => any,
  resultSucceededAction: (result: any) => any,
  resultFailedAction: (result: any) => any,
) {
  return function* (action: {
    payload: any;
    meta: { resolve: () => void; reject: () => void };
  }) {
    let result;
    try {
      result = yield call(apiAction, action.payload);
      yield call(action.meta.resolve as any, result);
      yield put(resultSucceededAction(result));
    } catch (exception) {
      console.warn(exception);
      // Something went wrong. We reject the promise.
      yield call(action.meta.reject as any, exception);
      result = exception;
      yield put(resultFailedAction(result));
    }
  };
}
